import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import reportWebVitals from "./reportWebVitals";
import store from "./store";
import theme from "./modules/common/style/theme";

import { CssBaseline, GlobalStyles, ThemeProvider } from "@mui/material";

import { SnackbarProvider } from "notistack";

import "./modules/common/style/index.css";
import App from "./App";

const globalStyles = (
  <GlobalStyles
    styles={{
      a: {
        "&:hover": {
          textDecoration: "underline",
        },
        "&:active": {
          color: "#ff6c0e",
        },
        "&:visited": {
          color: "#ff6c0e",
        },
        color: "#201751",
        textDecoration: "none",
      },
    }}
  />
);

//React 18 update
const root = createRoot(document.getElementById("root"));

root.render(
  <ThemeProvider theme={theme}>
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      autoHideDuration={6000}
    >
      <CssBaseline />
      {globalStyles}
      <Provider store={store}>
        <App />
      </Provider>
    </SnackbarProvider>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
